import React from 'react';
import classNames from 'classnames';

export const Icons = [
  'attachment',
  'search',
  'jobboard',
  'bookmark',
  'bookmark-filled',
  'add',
  'cart',
  'check',
  'dropdown-down',
  'dropdown-up',
  'my-quote',
  'reply',
  'close',
  'edit',
  'copy',
  'delete',
  'information',
  'more',
  'clock',
  'cancel',
  'sm-alert',
  'sm-check',
  'sm-bookmark',
  'sm-bookmark-filled',
  'sm-delete',
  'sm-close',
  'sm-email',
  'sm-information',
  'sm-more',
  'sm-noti-supplier',
  'sm-user',
  'sm-supplier',
  'sm-edit',
  'sm-cancel',
  'sm-attachment',
  'sm-history',
  'sm-dropdown-left',
  'sm-dropdown-right',
  'sm-export',
  'sm-clock',
] as const;
export type IconType = typeof Icons[number];

export const EMColors = ['success', 'sub-title', 'warning'] as const;
export type ColorType = typeof EMColors[number];

export interface PIconProps {
  icon: IconType;
  color?: ColorType;
  inactive?: boolean;
  className?: string;
  onClick?: (e: any) => void;
}

export function EMIcon({
  icon,
  color,
  inactive,
  className,
  onClick,
  children,
}: React.PropsWithChildren<PIconProps>): React.FunctionComponentElement<PIconProps> {
  const iconInactive = { 'icon-inactive': inactive };
  switch (icon) {
    default:
      return (
        <i
          className={classNames(
            `icon-${icon}`,
            color ? `color-${color}` : '',
            iconInactive,
            className,
          )}
          onClick={(e) => {
            onClick && onClick(e);
          }}
        >
          {children}
        </i>
      );
  }
}
